import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  Image,
  SendRequestCallback,
  Specimen,
  SpecimenFormData,
} from "../../types";
import { showError } from "../notifications";

interface PatchSpecimensByCollectionId {
  sendRequest: SendRequestCallback<any, { data: SpecimenFormData }, any>;
  data: SpecimenFormData;
  specimenId: string;
  collectionId: string;
}

export const updateSpecimen = createAsyncThunk(
  "specimens/updateSpecimen",
  async (
    {
      sendRequest,
      data,
      specimenId,
      collectionId,
    }: PatchSpecimensByCollectionId,
    { dispatch }
  ) => {
    try {
      await sendRequest("patch")({
        url: `/specimen/${specimenId}`,
        data,
      });
      return {
        specimenId,
        data,
        collectionId,
      };
    } catch (err) {
      dispatch(showError("Failed to update Specimen"));
      console.log(err);
    }
  }
);

interface FetchSpecimensByCollectionId {
  sendRequest: SendRequestCallback<
    any,
    any,
    { data: Specimen[]; count: number }
  >;
  collectionId: string;
  page: number;
  pageSize: number;
}

export const fetchSpecimensByCollectionId = createAsyncThunk(
  "specimens/fetchSpecimensByCollectionId",
  async (
    { sendRequest, collectionId, page, pageSize }: FetchSpecimensByCollectionId,
    { dispatch }
  ) => {
    try {
      const response = await sendRequest("get")({
        url: `/collection/${collectionId}/specimens?page=${page}&pageSize=${pageSize}`,
      });
      return response?.data;
    } catch (err) {
      dispatch(showError("Failed to update Collection Sites"));
      console.log(err);
    }
  }
);

interface FetchSpecimenImagesById {
  sendRequest: SendRequestCallback<any, any, { data: Image[] }>;
  specimenId: string;
  collectionId: string;
}

export const fetchSpecimenImagesById = createAsyncThunk(
  "specimens/fetchSpecimenImagesById",
  async (
    {
      sendRequest,
      specimenId = "",
      collectionId = "",
    }: FetchSpecimenImagesById,
    { dispatch }
  ) => {
    if (specimenId === "") {
      return;
    }
    try {
      const response = await sendRequest("get")({
        url: `/specimen/${specimenId}/images?compressed=true`,
      });

      return { specimenId, collectionId, images: response.data.data };
    } catch (err) {
      dispatch(showError("Failed to fetch Specimen images"));
      console.log(err);
    }
  }
);
